// https://vuex.vuejs.org/en/getters.html

export default {
  product_sets(state) {
    return state.product_sets;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  totalCount(state) {
    return state.totalCount;
  },
  filterValues(state) {
    return state.filterValues;
  },
  fieldHandles(state) {
    return state.fieldHandles;
  }
};
